import React from 'react';
import classes from './Header.css';

const header = (props) => (
<div className={classes.Header}>
    <img src="https://cdn.shopify.com/s/files/1/0390/9805/products/Hop-Pale-Ale_grande.png?v=1395710510" />
    <h1>OPISKALIJA</h1>
    <i>Beta 1.0</i>
</div>
);

export default header;

// https://static.thenounproject.com/png/9255-200.png
// https://icon-library.net/images/hops-icon/hops-icon-13.jpg
// https://cdn.shopify.com/s/files/1/0390/9805/products/Hop-Pale-Ale_grande.png?v=1395710510


// WEBPACK FOOTER //
// ./src/Components/Header/Header.js